import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class ZoomOutButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.zoomOutButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M32,29.17L21.77,18.95a12,12,0,1,0-2.83,2.83L29.17,32ZM14,14H4V10H20v4H14Z" />
				</svg>
			</i>
		</Button>;
	}
}
